
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="https://static.readdy.ai/image/74d1e4e79521c370342183571976e552/640721aa39941874b11ee1cb82c47c85.png" 
                alt="JL Security Logo - Security Risk Compliance North Wales" 
                title="JL Security"
                className="h-12 w-auto"
              />
              <div>
                <h3 className="text-xl font-bold text-white font-poppins">JL Security</h3>
                <p className="text-xs text-gray-300 font-inter">Security, Risk &amp; Compliance</p>
              </div>
            </div>
            <p className="text-sm text-gray-300 mb-4 font-inter">
              Practical <strong className="text-gray-200">security, risk and compliance solutions</strong> for organisations across <strong className="text-gray-200">North Wales</strong> and the UK
            </p>
            <div className="flex gap-4">
              <a href="https://www.facebook.com/profile.php?id=61585193507086" target="_blank" rel="noopener noreferrer nofollow" aria-label="JL Security Facebook page" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-red-600 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="https://www.linkedin.com/in/john-lewis-753930124/" target="_blank" rel="noopener noreferrer nofollow" aria-label="John Lewis LinkedIn profile" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-red-600 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <nav aria-label="Quick Links">
            <h3 className="text-lg font-bold text-white mb-6 font-poppins">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-300 hover:text-white transition-colors duration-300 text-sm font-inter cursor-pointer">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-white transition-colors duration-300 text-sm font-inter cursor-pointer">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/training" className="text-gray-300 hover:text-white transition-colors duration-300 text-sm font-inter cursor-pointer">
                  Training &amp; Certification
                </Link>
              </li>
              <li>
                <Link to="/certifications" className="text-gray-300 hover:text-white transition-colors duration-300 text-sm font-inter cursor-pointer">
                  Certifications
                </Link>
              </li>
              <li>
                <Link to="/martyns-law" className="text-gray-300 hover:text-white transition-colors duration-300 text-sm font-inter cursor-pointer">
                  Martyn&apos;s Law
                </Link>
              </li>
            </ul>
          </nav>

          {/* Services */}
          <nav aria-label="Our Services">
            <h4 className="text-lg font-bold mb-6 font-poppins">
              <a href="/services/consultancy" className="text-white hover:text-red-400 transition-colors cursor-pointer">Our Services</a>
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/services/security-systems" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer font-inter">Security Systems</Link>
              </li>
              <li>
                <Link to="/services/fire-safety" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer font-inter">Fire Safety Solutions</Link>
              </li>
              <li>
                <Link to="/services/risk-assessment" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer font-inter">Risk Assessment</Link>
              </li>
              <li>
                <Link to="/services/compliance" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer font-inter">Compliance Solutions</Link>
              </li>
              <li>
                <Link to="/services/maintenance" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer font-inter">Maintenance &amp; Support</Link>
              </li>
              <li>
                <Link to="/services/security-event-operations" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer font-inter">Security &amp; Event Operations</Link>
              </li>
            </ul>
          </nav>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-6 font-poppins">
              <a href="/#contact" className="text-white hover:text-red-400 transition-colors cursor-pointer">Contact Info</a>
            </h4>
            <div className="space-y-4">
              <div>
                <p className="text-sm font-semibold text-white mb-1 font-poppins">JL Security &amp; Risk Consultancy</p>
                <p className="text-sm text-gray-400 font-inter">Operating across North Wales &amp; the North West</p>
                <p className="text-xs text-gray-500 mt-1 font-inter italic">Office address provided to clients upon engagement</p>
              </div>
              
              <div className="flex items-start gap-3">
                <i className="ri-phone-line text-red-600 text-lg mt-1"></i>
                <a href="tel:+447834561015" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer font-inter">
                  +44 7834 561015
                </a>
              </div>
              
              <div className="flex items-start gap-3">
                <i className="ri-mail-line text-red-600 text-lg mt-1"></i>
                <a href="mailto:info@jl-security.co.uk" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer font-inter">
                  info@jl-security.co.uk
                </a>
              </div>
              
              <div className="flex items-start gap-3">
                <i className="ri-time-line text-red-600 text-lg mt-1"></i>
                <div className="text-sm text-gray-400 font-inter">
                  <p>Mon&ndash;Fri 8am&ndash;6pm</p>
                  <p className="text-xs text-gray-500 mt-1">24/7 Emergency Support</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col gap-6">
            {/* Policy Links */}
            <nav aria-label="Policy Links" className="flex flex-wrap justify-center items-center gap-x-4 gap-y-2 text-sm text-gray-400">
              <Link to="/privacy-policy" className="hover:text-white transition-colors duration-300 cursor-pointer">Privacy Policy</Link>
              <span className="text-gray-600">&bull;</span>
              <Link to="/terms-of-service" className="hover:text-white transition-colors duration-300 cursor-pointer">Terms of Service</Link>
              <span className="text-gray-600">&bull;</span>
              <Link to="/anti-bribery-policy" className="hover:text-white transition-colors duration-300 cursor-pointer">Anti-Bribery Policy</Link>
              <span className="text-gray-600">&bull;</span>
              <Link to="/safeguarding-policy" className="hover:text-white transition-colors duration-300 cursor-pointer">Safeguarding Policy</Link>
              <span className="text-gray-600">&bull;</span>
              <Link to="/human-rights-policy" className="hover:text-white transition-colors duration-300 cursor-pointer">Human Rights Policy</Link>
              <span className="text-gray-600">&bull;</span>
              <Link to="/health-safety-policy" className="hover:text-white transition-colors duration-300 cursor-pointer">Health &amp; Safety Policy</Link>
              <span className="text-gray-600">&bull;</span>
              <Link to="/equality-diversity-inclusion-policy" className="hover:text-white transition-colors duration-300 cursor-pointer">Equality, Diversity &amp; Inclusion</Link>
              <span className="text-gray-600">&bull;</span>
              <Link to="/environmental-sustainability-policy" className="hover:text-white transition-colors duration-300 cursor-pointer">Environmental &amp; Sustainability</Link>
              <span className="text-gray-600">&bull;</span>
              <Link to="/martyns-law" className="hover:text-white transition-colors duration-300 cursor-pointer">Martyn&apos;s Law</Link>
            </nav>

            {/* Copyright and Credits */}
            <div className="flex flex-col md:flex-row justify-between items-center gap-4">
              <p className="text-sm text-gray-400 font-inter text-center md:text-left">
                &copy; 2025 JL Security. All rights reserved.
              </p>
              <div className="flex items-center gap-4">
                <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer nofollow" className="text-sm text-gray-500 hover:text-gray-300 transition-colors cursor-pointer font-inter whitespace-nowrap">
                  Powered by Readdy
                </a>
                <span className="text-gray-700">|</span>
                <a href="https://www.coolmediamarketing.co.uk" target="_blank" rel="noopener noreferrer nofollow" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer font-inter whitespace-nowrap">
                  Designed by Coolmedia Marketing
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
